import axios from 'axios';

// Platform CVE feed — OPERATOR endpoints (SUPER_ADMIN).
//
// "Operator" is the person running the whole platform; "admin" runs one tenant.
// The advisory corpus is one shared copy of public CVE Program data, so syncing
// it, scheduling it, browsing it and wiping it are cross-tenant actions and live
// here rather than on any tenant API. Tenants read the corpus through their own
// /api/v1.0/blend/vulnerabilities endpoints and keep their own findings.
const BASE = '/api/operator/cve-feed';

const cveFeedService = {
  // -> the SHARED state: schedule flag, live run progress, corpus counters and
  // the CVE Program attribution. Everything here comes from one database row,
  // so every operator polling it sees the same run at the same numbers.
  status: async () => {
    const res = await axios.get(BASE);
    return res.data || {};
  },

  // mode: 'auto' (baseline only when its date moved on, else the unseen
  // deltas) | 'baseline' (force a full rebuild) | 'delta'
  //
  // Returns 202 with the current state — the work runs in the background and
  // survives the browser closing. A 409 means a sync is ALREADY running and
  // this operator is now watching it; the error body carries the same state
  // payload plus who started it, so the caller must not treat it as a failure.
  sync: (mode = 'auto') => axios.post(`${BASE}/sync`, null, { params: { mode } }),

  // The recurring download loop — an operator switch stored in the database,
  // not a config flag. Turning it off leaves manual sync available.
  setSchedule: (enabled) => axios.post(`${BASE}/schedule`, null, { params: { enabled } }),

  // Release a lock left behind by a replica that died mid-sync.
  unlock: () => axios.post(`${BASE}/unlock`),

  // The audit trail — one row per run, newest first. Server-side paged.
  runs: async (params) => {
    const res = await axios.get(`${BASE}/runs`, { params });
    return res.data || {};
  },

  // One page of the shared corpus. Always paged — it is ~150,000 rows.
  advisories: async (params) => {
    const res = await axios.get(`${BASE}/advisories`, { params });
    return res.data || {};
  },

  // source: 'cve' (the synced corpus) | 'manual' (operator CSV imports)
  clear: (source) => axios.delete(`${BASE}/advisories`, { params: { source } }),
};

export default cveFeedService;
